import { render, staticRenderFns } from "./Normativity.vue?vue&type=template&id=a6e54d24&scoped=true&lang=pug&"
import script from "./Normativity.vue?vue&type=script&lang=js&"
export * from "./Normativity.vue?vue&type=script&lang=js&"
import style0 from "./Normativity.vue?vue&type=style&index=0&id=a6e54d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e54d24",
  null
  
)

export default component.exports